import { ActionTree, ActionContext } from 'vuex';
import { RootState } from '@/store';
import { State } from './state';
import { Mutations } from './mutations';
import { LoaderActionTypes as LoaderActionTypes } from './action-types';
import { LoaderMutationTypes } from './mutation-types';

type AugmentedActionContext = {
  commit<K extends keyof Mutations>(key: K): ReturnType<Mutations[K]>;
} & Omit<ActionContext<State, RootState>, 'commit'>;

export interface Actions {
  [LoaderActionTypes.ACTION_SHOW]({ commit }: AugmentedActionContext): void;
  [LoaderActionTypes.ACTION_DONE]({ commit }: AugmentedActionContext): void;
  [LoaderActionTypes.ACTION_HIDE]({ commit }: AugmentedActionContext): void;
  [LoaderActionTypes.ACTION_NAVIGATION_SHOW]({ commit }: AugmentedActionContext): void;
  [LoaderActionTypes.ACTION_NAVIGATION_HIDE]({ commit }: AugmentedActionContext): void;
  [LoaderActionTypes.ACTION_PENDING]({ commit }: AugmentedActionContext): void;
}

export const actions: ActionTree<State, RootState> & Actions = {
  [LoaderActionTypes.ACTION_SHOW]({ commit }) {
    commit(LoaderMutationTypes.SHOW);
  },
  [LoaderActionTypes.ACTION_DONE]({ commit }) {
    commit(LoaderMutationTypes.DONE);
  },
  [LoaderActionTypes.ACTION_HIDE]({ commit }) {
    commit(LoaderMutationTypes.HIDE);
  },
  [LoaderActionTypes.ACTION_NAVIGATION_SHOW]({ commit }) {
    commit(LoaderMutationTypes.NAVIGATION_SHOW);
  },
  [LoaderActionTypes.ACTION_NAVIGATION_HIDE]({ commit }) {
    commit(LoaderMutationTypes.NAVIGATION_HIDE);
  },
  [LoaderActionTypes.ACTION_PENDING]({ commit }) {
    commit(LoaderMutationTypes.PENDING);
  }
};
